import { render, staticRenderFns } from "./DeductionsPlanNameTable.vue?vue&type=template&id=a65939e8&"
import script from "./DeductionsPlanNameTable.vue?vue&type=script&lang=js&"
export * from "./DeductionsPlanNameTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports